import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import React from 'react'
import styled from 'styled-components'

const Background = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  opacity: 0.6;

  &.bronze {
    background: linear-gradient(39deg, ${props => props.theme.palette.product.loyalty.bronze.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.bronze.normalBackground} 100%);
  }

  &.silver {
    background: linear-gradient(39deg, ${props => props.theme.palette.product.loyalty.silver.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.silver.normalBackground} 100%);
  }

  &.gold {
    background: linear-gradient(39deg, ${props => props.theme.palette.product.loyalty.gold.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.gold.normalBackground} 100%);
  }

  &.platinum {
    background: linear-gradient(39deg, ${props => props.theme.palette.product.loyalty.platinum.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.platinum.normalBackground} 100%);
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.50) 52%, rgba(255, 255, 255, 0.00) 100%);
`

const Container = styled.div`
  width: 100%;
  height: 100%;
`

interface Props {
  background: App.SiteTakeoverBackground;
  className?: string;
}

function TriplePointTakeoverBackground(props: Props) {
  const { background, className } = props
  const [tier] = useCurrentLoyaltyTier()

  return <Container className={className}>
    <Background className={tier}>
      {background === 'hero' && <Overlay />}
    </Background>
  </Container>
}

export default TriplePointTakeoverBackground
